export default {
  items: [
    // {
    //   name: 'Dashboard',
    //   url: '/dashboard',
    //   icon: 'icon-speedometer',
    // },
    {
      title: true,
      name: 'Home',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    }, {
      name: 'Veicoli',
      url: '/vehicles',
      icon: 'icon-map',
    }, {
      title: true,
      name: 'Storici',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    }, {
      name: 'Richieste',
      url: '/requests',
      icon: 'icon-energy',
    }, {
      name: 'Percorsi',
      url: '/routes',
      icon: 'icon-graph',
    },
  ]
}
